import React from 'react'

export default function ProgressBar(props) {
    return (
        <div>
            <progress id="humidity" value={props.value} max="100"/>
        </div>
    )
}
